import { TeamSpotProps } from '@optools/components/team-spot';
import { BtcSchedulePipeline } from '@optools/services/operator-gateway/btc/types';
import { sortByFeedType } from '@optools/utils/feeds';
import { getTeamByFeedType } from '@optools/utils/pipeline';

import { PipelineCard } from './pipeline-card';

export interface PipelineListProps {
  away: TeamSpotProps['team'];
  gamePk: number;
  home: TeamSpotProps['team'];
  pipelines: BtcSchedulePipeline[];
}

export function PipelineList({ away, gamePk, home, pipelines }: PipelineListProps) {
  return (
    <ul className="z-10 space-y-2">
      {sortByFeedType(pipelines).map((pipeline) => {
        const team = getTeamByFeedType({ away, feedType: pipeline.feedType, home });
        return (
          <li key={`${pipeline.id}-${gamePk}`}>
            <PipelineCard gamePk={gamePk} pipeline={pipeline} team={team} />
          </li>
        );
      })}
    </ul>
  );
}
